import { useQuery } from '@apollo/client';
import { GetOperatorResponse, GetOperatorRequest, CITRIN_GET_OPERATOR } from '..';

export const useGetOperatorQuery = (id: string) => {
    const { data, previousData, ...rest } = useQuery<GetOperatorResponse, GetOperatorRequest>(CITRIN_GET_OPERATOR, {
        variables: { id },
        // fetchPolicy: 'cache-and-network'
        // onCompleted: (data) => console.log('[MGT] Users', data),

        // fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Setting', data),
    });

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getOperator,
        data: data?.CITRIN_MGT_getOperator ?? undefined,
    };
};
